import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from '../../../../store/actions/index';
import { getStyles } from '../../../../shared/utility';

import Button from '../../../UI/Button/Button';

import PaymentAccountToggle from './PaymentAccountToggle/PaymentAccountToggle';
import LanguageToggle from './LanguageToggle/LanguageToggle';

import menuStyles from '../Menu.scss';
const styles = getStyles(menuStyles);

const subMenu = (props) => {
    if (!['preferences', 'payment', 'language'].includes(props.menu)) {
        return null;
    }

    const backButton = (
        <Button
            events={{ click: props.goBack }}
            modifiers={['text']}
            classes={styles('submenu__back-button')}
            icon={'arrow-left'}
        >
            <span>{props.goBackText}</span>
        </Button>
    );

    const items = props.menu === 'payment' ? (
        <PaymentAccountToggle
            items={props.paymentAccountsData}
            selected={props.paymentAccountSelected}
            loading={props.paymentAccountsLoading}
            userName={props.userData.name}
            change={(value) => props.onUpdateUserPreferences(props.userData.id, value, 'preferences/preferredPaymentAccountId')} />
    ) : props.menu === 'language' ? (
        <LanguageToggle
            items={props.languageData}
            selected={props.languageSelected}
            change={(value) => props.onUpdateUserPreferences(props.userData.id, value, 'preferences/preferredLanguageCode')} />
    ) : null;


    return (
        <Fragment>
            <div className={styles('submenu__content')}>
                <p className={styles('submenu__title', 'align--center')}>
                    {backButton}
                    {props.title ? <strong>{props.title}</strong> : null}
                </p>
                {props.description ? (<p className={styles('submenu__description', 'c--text-light', 'line-height--small')}>{props.description}</p>) : null}
            </div>
            <ul className={styles('menu', 'no-list-style')}>
                {items}
            </ul>
        </Fragment>
    );
};

subMenu.propTypes = {
    // properties
    menu: PropTypes.string,
    goBackText: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,

    userData: PropTypes.object.isRequired,

    paymentAccountsData: PropTypes.arrayOf(PropTypes.object),
    paymentAccountsLoading: PropTypes.bool,
    paymentAccountSelected: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.object
    ]),
    languageData: PropTypes.arrayOf(PropTypes.object),
    languageSelected: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),

    // functions
    onUpdateUserPreferences: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
    pageRedirect: PropTypes.func.isRequired
};

const mapStateToProps = state => {
    return {
        userData: state.details.user.data,

        paymentAccountsData: state.list.paymentAccounts.data,
        paymentAccountsLoading: state.list.paymentAccounts.loading,
        paymentAccountSelected: state.details.user.data ? state.details.user.data.preferences.preferredPaymentAccountId : null,
        languageData: state.global.localization.available,
        languageSelected: state.details.user.data ? state.details.user.data.preferences.preferredLanguageCode : null,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onUpdateUserPreferences: (userId, value, path) => dispatch(actions.updateUserPreferences(userId, value, path))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(subMenu);



// WEBPACK FOOTER //
// ./src/components/Navigation/Menu/SubMenu/SubMenu.js